import { render, staticRenderFns } from "./Chiefs.vue?vue&type=template&id=5ebaec62&scoped=true"
import script from "./Chiefs.vue?vue&type=script&lang=js"
export * from "./Chiefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebaec62",
  null
  
)

export default component.exports